if(window.GMAP_KEY)
{
	require('./google/index.js');
}
else
{
	require('./leaflet/index.js');
}

$(document).ready(function() {
	$(document).on('click.gmap-marker', 'a[href^="map://"]', function(event) {
		event.preventDefault();
		var param = $(this).attr('href').replace('map://','').split(':');
		if(param.length==2)
		{
			if(param[1]=='!reset')
			{
				window.GMAP_INSTANCES[param[0]].map.hapiReset();
				$('a[href^="map://'+param[0]+':"]').removeClass('active')
			}
			else
			{
				window.GMAP_INSTANCES[param[0]].map.hapiZoomIn(param[1]);
				if(window.GMAP_INSTANCES[param[0]].markers[param[1]].length==1)
				{
					setTimeout(function(){
						window.GMAP_INSTANCES[param[0]].markers[param[1]][0].doClick($(this).hasClass('active') ? 'close':'open');
					},300)
				}
			}
		}
	});
});